import React, { useState } from "react"
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardTitle,
  Label,
  Button,
  Form,
  Input,
  InputGroup,
  FormFeedback,
} from "reactstrap"
import * as Yup from "yup"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useFormik } from "formik"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

import { useSelector, useDispatch } from "react-redux"
import { withRouter, Link } from "react-router-dom"

// actions
import { addRole } from "../../../store/actions"
import { useEffect } from "react"

const AddRole = props => {
  const dispatch = useDispatch()
  document.title = "Add Role"

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      user_role_name: "",
      user_role_short: "",
    },
    validationSchema: Yup.object({
      user_role_name: Yup.string().required("Please enter role"),
      user_role_short: Yup.string().required("Please enter role short"),
    }),
    onSubmit: values => {
      dispatch(addRole(values, props.history))
    },
  })

  const roles = useSelector(state => state.role)
  const { error } = useSelector(state => ({
    error: state.Role.error,
  }))

  useEffect(() => {
    if (error) {
      toast.dismiss()
      toast.error(error, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      })
    }
  }, [error])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs breadcrumbItem="Add Role" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  {error ? <ToastContainer /> : ""}
                  <Form
                    id="role_form"
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >
                    <Row>
                      <Col md={6}>
                        <div className="mb-3">
                          <Label htmlFor="user_role_name">
                            User Role Name
                            <span className="text-danger">*</span>
                          </Label>
                          <Input
                            type="text"
                            name="user_role_name"
                            autoComplete="off"
                            className={
                              validation.touched.user_role_name &&
                              validation.errors.user_role_name
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            id="user_role_name"
                            placeholder="Enter Role Name"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.user_role_name || ""}
                          />
                          {validation.touched.user_role_name &&
                          validation.errors.user_role_name ? (
                            <FormFeedback type="invalid">
                              {validation.errors.user_role_name}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="mb-3">
                          <Label htmlFor="user_role_short">
                            User Role Short
                            <span className="text-danger">*</span>
                          </Label>
                          <Input
                            type="text"
                            name="user_role_short"
                            autoComplete="off"
                            className={
                              validation.touched.user_role_short &&
                              validation.errors.user_role_short
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            id="user_role_short"
                            placeholder="Enter role short"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.user_role_short || ""}
                          />
                          {validation.touched.user_role_short &&
                          validation.errors.user_role_short ? (
                            <FormFeedback type="invalid">
                              {validation.errors.user_role_short}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                    <div>
                      {roles && roles.loading ? (
                        <button
                          type="submit"
                          className="btn btn-primary w-md"
                          disabled
                        >
                          Adding ...
                        </button>
                      ) : (
                        <button type="submit" className="btn btn-primary w-md">
                          Add
                        </button>
                      )}
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        {/* container-fluid */}
      </div>
    </React.Fragment>
  )
}

export default AddRole
